import { parseUtcTimestamp } from './parse-utc-timestamp';

/**
 * Computes the offset that has to be added to the client clock to get the server time.
 *
 * All countdowns are calculated against this corrected time, never against the raw client clock: a client
 * clock that runs minutes off would otherwise unlock or lock the UI at the wrong time.
 * @param serverUtcNow The server time of the response as UTC timestamp.
 * @param receivedAt The client timestamp (epoch milliseconds) at which the response was received.
 * @returns The offset in milliseconds, `0` when the server time cannot be parsed.
 */
export function computeServerTimeOffset(serverUtcNow: string, receivedAt: number): number {
  const serverTime = parseUtcTimestamp(serverUtcNow);

  return serverTime === null ? 0 : serverTime - receivedAt;
}
